import { relationshipModel, UserRole } from '~/models';
export var Intent = /*#__PURE__*/ function(Intent) {
    Intent["AddPaymentMethod"] = "addPaymentMethod";
    Intent["OpenAccountantAccessRequest"] = "openAccountantAccessRequest";
    Intent["AccountingMapServices"] = "accountingMapServices";
    Intent["AccountingSetupMapContacts"] = "accountingSetupMapContacts";
    Intent["InvoiceApprovePayment"] = "invoiceApprovePayment";
    Intent["InvoiceResolvePayment"] = "invoiceResolvePayment";
    Intent["InvoiceStopPayment"] = "invoiceStopPayment";
    Intent["InvoicePayNow"] = "invoicePayNow";
    Intent["InvoiceResumePayment"] = "invoiceResumePayment";
    Intent["ApproveCharge"] = "approveCharge";
    Intent["InviteTeamMember"] = "inviteTeamMember";
    Intent["RemoveAccountAccess"] = "removeAccountAccess";
    Intent["DeclineAutoApproval"] = "declineAutoApproval";
    Intent["ApproveAllAmendments"] = "approveAllAmendments";
    Intent["InvoiceRejectPaymentExtension"] = "invoiceRejectPaymentExtension";
    Intent["InvoiceApprovePaymentExtension"] = "invoiceApprovePaymentExtension";
    Intent["InvoiceRetryCharge"] = "invoiceRetryCharge";
    Intent["ApproveAllBar"] = "approveAllBar";
    Intent["SelectPackage"] = "selectPackage";
    Intent["DownloadAgreementPdf"] = "downloadAgreementPdf";
    Intent["DuplicateAgreement"] = "duplicateAgreement";
    Intent["CopyRelationshipDirectLink"] = "copyRelationshipDirectLink";
    Intent["TerminateAgreement"] = "terminateAgreement";
    Intent["SendProposal"] = "sendProposal";
    Intent["SendProposalReminder"] = "sendProposalReminder";
    Intent["EditProposal"] = "editProposal";
    Intent["DuplicateProposal"] = "duplicateProposal";
    Intent["CancelProposal"] = "cancelProposal";
    Intent["InvoiceMarkPaidExternally"] = "invoiceMarkPaidExternally";
    Intent["InvoiceResend"] = "invoiceResend";
    Intent["InvoiceDownload"] = "invoiceDownload";
    Intent["InvoiceVoid"] = "invoiceVoid";
    Intent["InvoiceUnvoid"] = "invoiceUnvoid";
    Intent["InvoiceUnmarkPaidExternally"] = "invoiceUnmarkPaidExternally";
    Intent["InvoiceCopyLink"] = "invoiceCopyLink";
    Intent["UpdateBusinessDetails"] = "updateBusinessDetails";
    Intent["ChangeRole"] = "changeRole";
    Intent["ResendMemberInvitation"] = "resendMemberInvitation";
    Intent["RemoveFromTeam"] = "removeFromTeam";
    Intent["UpdateProfile"] = "updateProfile";
    Intent["OpenHelpMenu"] = "openHelpMenu";
    Intent["ApproveProposal"] = "approveProposal";
    Intent["ProposalSwitchCompany"] = "proposalSwitchCompany";
    Intent["AccountingMapAccounts"] = "accountingMapAccounts";
    Intent["AccountingDisconnect"] = "accountingDisconnect";
    Intent["ClientViewProposal"] = "clientViewProposal";
    Intent["VendorViewProposal"] = "vendorViewProposal";
    Intent["CreateProposalTemplate"] = "createProposalTemplate";
    Intent["EditProposalTemplate"] = "editProposalTemplate";
    Intent["ViewProposalTemplate"] = "viewProposalTemplate";
    Intent["UseProposalTemplate"] = "useProposalTemplate";
    Intent["RenameProposalTemplate"] = "renameProposalTemplate";
    Intent["RemoveProposalTemplate"] = "removeProposalTemplate";
    Intent["DiscardDraft"] = "discardDraft";
    Intent["AddCharge"] = "addCharge";
    Intent["AddCredit"] = "addCredit";
    Intent["RemoveCredit"] = "removeCredit";
    Intent["Bill"] = "bill";
    Intent["RemoveCharge"] = "removeCharge";
    Intent["EnterAccountantAccess"] = "enterAccountantAccess";
    Intent["ClientCreateVendorAccount"] = "clientCreateVendorAccount";
    Intent["RequestRefund"] = "requestRefund";
    Intent["SelectOptionalService"] = "selectOptionalService";
    Intent["ExportAgreementsToCsv"] = "exportAgreementsToCsv";
    Intent["BrandSetup"] = "brandSetup";
    Intent["CreateServiceTemplate"] = "createServiceTemplate";
    Intent["ApproveProposalOnBehalf"] = "approveProposalOnBehalf";
    return Intent;
}({});
const forbiddenTooltipText = "You don't have permission to perform this action. Contact the account owner to grant you access.";
const openToAll = new Set([
    UserRole.Accountant,
    UserRole.Admin,
    UserRole.Member,
    UserRole.Owner,
    UserRole.AnchorAdmin,
    UserRole.Reviewer
]);
const openToOwnerAdminAndAnchorAdmin = new Set([
    UserRole.Admin,
    UserRole.Owner,
    UserRole.AnchorAdmin
]);
const openToAllExceptMembersAndReviewers = new Set([
    UserRole.Owner,
    UserRole.Admin,
    UserRole.Accountant,
    UserRole.AnchorAdmin
]);
const openToAllExceptAccountantAndReviewer = new Set([
    UserRole.Owner,
    UserRole.Admin,
    UserRole.Member,
    UserRole.AnchorAdmin
]);
const openToAllExceptAnchorAdminAndReviewer = new Set([
    UserRole.Owner,
    UserRole.Admin,
    UserRole.Member,
    UserRole.Accountant
]);
const openToOwnerAndAdmin = new Set([
    UserRole.Admin,
    UserRole.Owner
]);
const openToOwnerAdminAndMember = new Set([
    UserRole.Owner,
    UserRole.Admin,
    UserRole.Member
]);
const openToAllExpectAnchorAdminAndAccountant = new Set([
    UserRole.Owner,
    UserRole.Admin,
    UserRole.Member,
    UserRole.Reviewer
]);
const openToAdminAndMember = new Set([
    UserRole.Admin,
    UserRole.Member
]);
const accessControlAllowList = {
    ["addPaymentMethod"]: openToAll,
    ["openAccountantAccessRequest"]: openToOwnerAdminAndAnchorAdmin,
    ["accountingMapServices"]: openToOwnerAdminAndAnchorAdmin,
    ["accountingSetupMapContacts"]: openToOwnerAdminAndAnchorAdmin,
    ["accountingMapAccounts"]: openToAllExceptAccountantAndReviewer,
    ["accountingDisconnect"]: openToAllExceptAccountantAndReviewer,
    ["invoiceApprovePayment"]: openToOwnerAdminAndAnchorAdmin,
    ["invoiceResolvePayment"]: openToOwnerAdminAndAnchorAdmin,
    ["invoiceStopPayment"]: openToOwnerAndAdmin,
    ["invoicePayNow"]: openToOwnerAdminAndAnchorAdmin,
    ["invoiceResumePayment"]: openToOwnerAdminAndAnchorAdmin,
    ["approveCharge"]: openToOwnerAndAdmin,
    ["inviteTeamMember"]: openToOwnerAdminAndAnchorAdmin,
    ["removeAccountAccess"]: openToOwnerAdminAndAnchorAdmin,
    ["declineAutoApproval"]: openToOwnerAdminAndAnchorAdmin,
    ["approveAllAmendments"]: openToOwnerAdminAndAnchorAdmin,
    ["invoiceRejectPaymentExtension"]: openToOwnerAdminAndAnchorAdmin,
    ["invoiceApprovePaymentExtension"]: openToOwnerAdminAndAnchorAdmin,
    ["invoiceRetryCharge"]: openToOwnerAndAdmin,
    ["approveAllBar"]: openToOwnerAndAdmin,
    ["selectPackage"]: openToOwnerAdminAndAnchorAdmin,
    ["removeFromTeam"]: openToOwnerAdminAndAnchorAdmin,
    ["duplicateAgreement"]: openToAllExceptAccountantAndReviewer,
    ["terminateAgreement"]: openToAllExceptAccountantAndReviewer,
    ["sendProposal"]: openToAllExceptAnchorAdminAndReviewer,
    ["sendProposalReminder"]: openToAllExceptAccountantAndReviewer,
    ["editProposal"]: openToAllExceptAccountantAndReviewer,
    ["duplicateProposal"]: openToAllExceptAccountantAndReviewer,
    ["cancelProposal"]: openToAllExceptAccountantAndReviewer,
    ["invoiceMarkPaidExternally"]: openToOwnerAdminAndMember,
    ["invoiceResend"]: openToAllExceptAccountantAndReviewer,
    ["invoiceDownload"]: openToAll,
    ["invoiceVoid"]: openToOwnerAdminAndMember,
    ["invoiceUnvoid"]: openToAll,
    ["invoiceUnmarkPaidExternally"]: openToAll,
    ["invoiceCopyLink"]: openToAll,
    ["updateBusinessDetails"]: openToAllExceptAccountantAndReviewer,
    ["changeRole"]: openToAllExceptAccountantAndReviewer,
    ["resendMemberInvitation"]: openToAllExceptAccountantAndReviewer,
    ["updateProfile"]: openToAll,
    ["openHelpMenu"]: openToAllExceptAccountantAndReviewer,
    ["approveProposal"]: openToAdminAndMember,
    ["proposalSwitchCompany"]: openToAllExceptAccountantAndReviewer,
    ["downloadAgreementPdf"]: openToAll,
    ["copyRelationshipDirectLink"]: openToAll,
    ["clientViewProposal"]: openToAllExceptAccountantAndReviewer,
    ["vendorViewProposal"]: openToAll,
    ["createProposalTemplate"]: openToAllExceptMembersAndReviewers,
    ["editProposalTemplate"]: openToAllExceptMembersAndReviewers,
    ["viewProposalTemplate"]: openToAll,
    ["useProposalTemplate"]: openToAll,
    ["renameProposalTemplate"]: openToAllExceptMembersAndReviewers,
    ["removeProposalTemplate"]: openToAllExceptMembersAndReviewers,
    ["discardDraft"]: openToAll,
    ["addCharge"]: openToAllExceptAnchorAdminAndReviewer,
    ["addCredit"]: openToAllExceptAnchorAdminAndReviewer,
    ["removeCredit"]: openToAllExceptAnchorAdminAndReviewer,
    ["bill"]: openToAllExceptAnchorAdminAndReviewer,
    ["removeCharge"]: openToAllExceptAnchorAdminAndReviewer,
    ["enterAccountantAccess"]: openToAllExceptAnchorAdminAndReviewer,
    ["clientCreateVendorAccount"]: openToAllExpectAnchorAdminAndAccountant,
    ["requestRefund"]: openToOwnerAdminAndAnchorAdmin,
    ["selectOptionalService"]: openToOwnerAdminAndAnchorAdmin,
    ["exportAgreementsToCsv"]: openToOwnerAdminAndAnchorAdmin,
    ["brandSetup"]: openToOwnerAdminAndAnchorAdmin,
    ["createServiceTemplate"]: openToOwnerAdminAndAnchorAdmin,
    ["approveProposalOnBehalf"]: openToOwnerAdminAndMember
};
function getForbiddenTooltipText(intent, primaryName) {
    switch(intent){
        case "selectOptionalService":
            return "Only ".concat(primaryName || 'primary recipient', " can select optional services");
        case "selectPackage":
            return "Only ".concat(primaryName, " can select package for this proposal");
        default:
            return forbiddenTooltipText;
    }
}
export function getIntentBehavior(userRole) {
    let opts = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    var _opts_relationshipState, _opts_relationshipState1;
    const isSignatory = ((_opts_relationshipState = opts.relationshipState) === null || _opts_relationshipState === void 0 ? void 0 : _opts_relationshipState.relationship) && opts.userId && relationshipModel.isSignatory(opts.relationshipState.relationship, opts.userId);
    const primaryName = ((_opts_relationshipState1 = opts.relationshipState) === null || _opts_relationshipState1 === void 0 ? void 0 : _opts_relationshipState1.relationship) ? relationshipModel.buyerFullName(opts.relationshipState.relationship) : undefined;
    // eslint-disable-next-line no-console
    const warn = (intent)=>console.warn('[access-control] unrecognized intent:', intent);
    const isAllowed = (intent)=>{
        var _opts_relationshipState, _opts_relationshipState1, _opts_relationshipState2;
        const isOwnerWithoutSignatories = ((_opts_relationshipState = opts.relationshipState) === null || _opts_relationshipState === void 0 ? void 0 : _opts_relationshipState.relationship) && UserRole.Owner === userRole && !relationshipModel.hasSignatories(opts.relationshipState.relationship);
        const isBuyer = ((_opts_relationshipState1 = opts.relationshipState) === null || _opts_relationshipState1 === void 0 ? void 0 : _opts_relationshipState1.relationship) && relationshipModel.isBuyer(opts.relationshipState.relationship, opts.userId);
        const isBuyerAdmin = isBuyer && (userRole === UserRole.Admin || userRole === UserRole.Owner);
        if (intent === "approveProposal" && (isSignatory || isOwnerWithoutSignatories || isBuyerAdmin)) {
            return true;
        }
        if (intent === "approveProposal" && isBuyer && !isBuyerAdmin) {
            return false;
        }
        if ((intent === "selectPackage" || intent === "selectOptionalService") && isBuyer) {
            return true;
        }
        if (intent === "selectPackage" && ((_opts_relationshipState2 = opts.relationshipState) === null || _opts_relationshipState2 === void 0 ? void 0 : _opts_relationshipState2.isPreviewMode)) return true;
        const allowList = accessControlAllowList[intent];
        if (!allowList) {
            warn(intent);
            return true;
        }
        return allowList.has(userRole);
    };
    return {
        getDisabled (intent) {
            if (!userRole) return false;
            return !isAllowed(intent);
        },
        getTooltip (intent) {
            if (!userRole) return null;
            return isAllowed(intent) ? null : getForbiddenTooltipText(intent, primaryName);
        }
    };
}
